import { Controller } from "@hotwired/stimulus"

// FD-394: debounced live search for the help center. The search box submits its form
// — a GET into the `help_search_results` turbo-frame — a short beat after typing stops,
// so results update live without firing a request on every keystroke. No JS still works:
// the form submits normally on Enter.
export default class extends Controller {
  submit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.requestSubmit(), 200)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
